import { render } from "./Task.vue?vue&type=template&id=3355560b&scoped=true"
import script from "./Task.vue?vue&type=script&lang=js"
export * from "./Task.vue?vue&type=script&lang=js"

import "./Task.vue?vue&type=style&index=0&id=3355560b&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3355560b"]])

export default __exports__